module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg_add"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.firstStep),
      expression: "firstStep"
    }],
    staticClass: "changead"
  }, [_c('div', {
    staticClass: "changeadinput_create"
  }, [_c('el-input', {
    staticStyle: {
      "float": "left",
      "width": "120px",
      "margin-right": "5px"
    },
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.$route.params.metercode),
      callback: function($$v) {
        _vm.$set(_vm.$route.params, "metercode", $$v)
      },
      expression: "$route.params.metercode"
    }
  }), _vm._v(" "), (_vm.typeKey != 7) ? _c('el-input', {
    staticStyle: {
      "float": "left",
      "width": "120px",
      "margin-right": "5px"
    },
    attrs: {
      "placeholder": "请输入金额(元)",
      "maxlength": 5,
      "autofocus": true
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.typeKey == 7) ? _c('el-input', {
    staticStyle: {
      "float": "left",
      "width": "120px",
      "margin-right": "5px"
    },
    attrs: {
      "placeholder": "请输入吨数(吨)",
      "maxlength": 5,
      "autofocus": true
    },
    model: {
      value: (_vm.total_dun),
      callback: function($$v) {
        _vm.total_dun = $$v
      },
      expression: "total_dun"
    }
  }) : _vm._e(), _vm._v(" "), [_c('el-select', {
    staticStyle: {
      "width": "145px",
      "float": "left"
    },
    attrs: {
      "placeholder": "请选择支付方式"
    },
    model: {
      value: (_vm.paytype),
      callback: function($$v) {
        _vm.paytype = $$v
      },
      expression: "paytype"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])
  }), 1)], _vm._v(" "), (_vm.paytype == 7) ? _c('p', {
    staticClass: "showRt"
  }, [_vm._v("声明：直充仅保证表正常运行，为系统提供数据支持，与实际缴费购买金额无关，并无其他实际意义。")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onNext
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("取 消")])], 1)], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ladderShow),
      expression: "ladderShow"
    }],
    staticClass: "infos"
  }, [_c('div', {
    staticClass: "infos_row"
  }, [_c('label', [_vm._v("当前阶梯：")]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.ladderinfo.level))]), _vm._v("阶梯")]), _vm._v(" "), _c('a', {
    staticClass: "right",
    attrs: {
      "href": "/explain/explain-rule",
      "target": "_blank"
    }
  }, [_vm._v("规则")])]), _vm._v(" "), _c('div', {
    staticClass: "infos_row"
  }, [_c('label', [_vm._v("当前本年电表用量：")]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.ladderinfo.yeartotal))]), _vm._v("度")])]), _vm._v(" "), _c('div', {
    staticClass: "infos_row"
  }, [_c('label', [_vm._v("超出阶梯用量：")]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.ladderinfo.exceed))]), _vm._v("度")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "infos_row"
  }, [_c('label', [_vm._v("充值金额：")]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.yuan(_vm.ladderinfo.money)))]), _vm._v("元")])]), _vm._v(" "), _c('div', {
    staticClass: "infos_row"
  }, [_c('label', [_vm._v("应补交阶梯差价：")]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.yuan(_vm.ladderinfo.diff)))]), _vm._v("元")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/explain/explain-detailed?yeartotal=' + _vm.ladderinfo.yeartotal + '&newyear=' + _vm.ladderinfo.newYear,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "infos_row"
  }, [_c('label', [_vm._v("存入零钱：")]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.ladderinfo.pocket_money))]), _vm._v("元 （零钱累计满1元系统自动充值到电表）")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "infos_row infos_red"
  }, [_c('label', [_vm._v("剩余金额：")]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.yuan(_vm.ladderinfo.amount)))]), _vm._v("元")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onLadder
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.firstStep = true, _vm.ladderShow = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.next),
      expression: "next"
    }],
    staticClass: "create"
  }, [_c('span', [_c('h4', [_vm._v("订单名称：")]), _vm._v(_vm._s(_vm.orderinfo.order_title))]), _vm._v(" "), _c('span', [_c('h4', [_vm._v("订单编号：")]), _vm._v(_vm._s(_vm.orderinfo.ordercode))]), _vm._v(" "), _c('span', [_c('h4', [_vm._v("表号：")]), _vm._v(_vm._s(_vm.orderinfo.metercode))]), _vm._v(" "), _c('span', [_c('h4', [_vm._v("业主姓名：")]), _vm._v(_vm._s(_vm.orderinfo.owner_name))]), _vm._v(" "), _c('span', [_c('h4', [_vm._v("业主电话：")]), _vm._v(_vm._s(_vm.orderinfo.owner_phone))]), _vm._v(" "), _c('span', [_c('h4', [_vm._v("地址：")]), _vm._v(_vm._s(_vm.orderinfo.address))]), _vm._v(" "), _c('span', [_c('h4', [_vm._v("支付方式：")]), _vm._v(" "), (1 == _vm.orderinfo.pay_type) ? _c('rt', [_vm._v("支付宝")]) : _vm._e(), _vm._v(" "), (2 == _vm.orderinfo.pay_type) ? _c('rt', [_vm._v("微信")]) : _vm._e(), _vm._v(" "), (3 == _vm.orderinfo.pay_type) ? _c('rt', [_vm._v("银联")]) : _vm._e(), _vm._v(" "), (4 == _vm.orderinfo.pay_type) ? _c('rt', [_vm._v("现金")]) : _vm._e(), _vm._v(" "), (5 == _vm.orderinfo.pay_type) ? _c('rt', [_vm._v("支票")]) : _vm._e(), _vm._v(" "), (6 == _vm.orderinfo.pay_type) ? _c('rt', [_vm._v("光大银行")]) : _vm._e(), _vm._v(" "), (7 == _vm.orderinfo.pay_type) ? _c('rt', [_vm._v("直充")]) : _vm._e()]), _vm._v(" "), (_vm.typeKey != 7) ? _c('span', [_c('h4', [_vm._v("支付前费用余额：")]), _vm._v(_vm._s(_vm.orderinfo.balance_before / 100) + " (元)")]) : _vm._e(), _vm._v(" "), (_vm.nextType == 1) ? _c('span', [_c('h4', [_vm._v("支付前本年用量：")]), _vm._v(_vm._s(_vm.orderinfo.yeartotal / 100) + "度")]) : _vm._e(), _vm._v(" "), (_vm.nextType == 1) ? _c('span', [_c('h4', [_vm._v("剩余金额：")]), _c('span', {
    staticClass: "text_blue text_bold"
  }, [_vm._v("￥" + _vm._s(_vm.orderinfo.meter_monry / 100))])]) : _vm._e(), _vm._v(" "), (_vm.typeKey != 7) ? _c('span', [_c('h4', [_vm._v("支付金额：")]), _vm._v(_vm._s(_vm.orderinfo.total / 100) + " (元)")]) : _vm._e(), _vm._v(" "), (_vm.nextType == 1) ? _c('span', [_c('h4', [_vm._v("补交阶梯差价：")]), _c('span', {
    staticClass: "text_red"
  }, [_vm._v("￥" + _vm._s(_vm.orderinfo.diff_money / 100))])]) : _vm._e(), _vm._v(" "), (_vm.nextType == 1) ? _c('span', [_c('h4', [_vm._v("存入零钱：")]), _vm._v("￥" + _vm._s(_vm.orderinfo.pocket_in / 100))]) : _vm._e(), _vm._v(" "), (_vm.typeKey != 7) ? _c('span', [_c('h4', [_vm._v("透支金额/吨数:")]), _c('span', {
    staticClass: "text_red"
  }, [_vm._v(_vm._s(_vm.orderinfo.overdraft / 100) + " (元)")])]) : _vm._e(), _vm._v(" "), (_vm.nextType == 1) ? _c('span', [_c('h4', [_vm._v("本次充值后零钱余额：")]), _vm._v("￥" + _vm._s(_vm.orderinfo.pocket_after / 100))]) : _vm._e(), _vm._v(" "), (_vm.nextType == 1) ? _c('span', [_c('h4', [_vm._v("本次充值后零钱支付：")]), _vm._v("￥" + _vm._s(_vm.orderinfo.pocket_out / 100))]) : _vm._e(), _vm._v(" "), (_vm.typeKey != 7) ? _c('span', [_c('h4', [_vm._v("支付后费用余额：")]), _vm._v(_vm._s(_vm.orderinfo.balance_after / 100) + " (元)")]) : _vm._e(), _vm._v(" "), (_vm.typeKey == 7) ? _c('span', [_c('h4', [_vm._v("支付前剩余吨数:")]), _vm._v(_vm._s(_vm.orderinfo.balance_before / 100) + " (吨)")]) : _vm._e(), _vm._v(" "), (_vm.typeKey == 7) ? _c('span', [_c('h4', [_vm._v("透支金额/吨数:")]), _vm._v(_vm._s(_vm.orderinfo.overdraft / 100) + " (元)")]) : _vm._e(), _vm._v(" "), (_vm.typeKey == 7) ? _c('span', [_c('h4', [_vm._v("支付金额：")]), _vm._v(_vm._s(_vm.orderinfo.total / 100) + " (元)")]) : _vm._e(), _vm._v(" "), (_vm.typeKey == 7) ? _c('span', [_c('h4', [_vm._v("支付后剩余吨数：")]), _vm._v(_vm._s(_vm.orderinfo.balance_after / 100) + " (吨)")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.successOrder
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), (_vm.erImg) ? _c('div', {
    staticClass: "er_img"
  }, [(_vm.orderinfo.pay_type == 2) ? _c('h2', [_vm._v("请使用微信扫描下方二维码")]) : _vm._e(), _vm._v(" "), (_vm.orderinfo.pay_type == 3) ? _c('h2', [_vm._v("请使用浏览器扫描下方二维码")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "qrcodes"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.payMessage))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.closeErImg
    }
  }, [_vm._v("关闭")])], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "/explain/explain-why",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infos_row"
  }, [_c('p', [_vm._v("您当前电量已超出标准范围，如继续购电则会自动扣除差价，如若同意则点击“确认”按钮继续操作。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-4682e8ce"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderCreate.vue
// module id = 530
// module chunks = 1